import 'babel-polyfill'

import Es6Promise from 'es6-promise'
Es6Promise.polyfill()


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//引入初始化样式
import './assets/base.css'


import './registerServiceWorker'

import "animate.css"
import animate from 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'


import {
  Carousel,
  CarouselItem,
} from 'element-ui';
Vue.use(Carousel);
Vue.use(CarouselItem);

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 
  ak: '36I5klLYrXvVKGrPr8yHjEYMXgmKETEK'
})
// import vueSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(vueSwiper)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.use(ViewUI);


Vue.prototype.isActive = 0;

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')